import { ReactElement } from 'react'

import { VatRatesContextProvider } from '@features/vatRates/contexts/vatRatesContext'

import { InvoiceSettingsFormContextProvider } from './contexts/invoiceSettingsFormContext'
import { InvoiceSettingsModalsContextProvider } from './contexts/invoiceSettingsModalsContext'
import { InvoiceSettingsForm } from './elements/InvoiceSettingsForm'
import { InvoiceSettingsModals } from './elements/InvoiceSettingsModals'
import { InvoiceSettingsPreview } from './elements/InvoiceSettingsPreview'
import * as Styled from './styles'

export const ExternalInvoiceSettings = (): ReactElement => (
  <VatRatesContextProvider>
    <InvoiceSettingsModalsContextProvider>
      <InvoiceSettingsFormContextProvider>
        <Styled.InvoiceSettingsWithPreviewWrapper>
          <InvoiceSettingsForm />
          <InvoiceSettingsPreview />
        </Styled.InvoiceSettingsWithPreviewWrapper>
        <InvoiceSettingsModals />
      </InvoiceSettingsFormContextProvider>
    </InvoiceSettingsModalsContextProvider>
  </VatRatesContextProvider>
)
